import { Edit, NumberInput, SimpleForm, TextField, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';

export const LocationEdit = (props: unknown) => (
  <Edit {...props} title={<CustomTitle />}>
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="title" />
      <TextInput source="direction" />
      <NumberInput source="order" />
    </SimpleForm>
  </Edit>
);
